<template>
    <ModalData
        size="large"
        :class="`modal-basemap-${basemapType}`"
        :title="modalTitle"
        :show="show"
        :needHeader="true"
        :needFooter="true"
        :relativeBackdrop="false"
        :contentCentered="true"
        :saveButton="saveButtonCfg"
        @close="onClose"
        @save="onSave">
        <div class="row">
            <div class="col-sm-12">
                <component
                    :is="basemapComponent"
                    :panelID="pageID"
                    :basemapUrl="basemapUrl"
                    :basemapItems="basemapItems"
                    :readonlyFormItem="readonlyFormItem"
                    :keyChilds="keyChilds"
                    :keyGroup="keyGroup"
                    v-model="form"
                    @selected="onSelectedItem"
                />
            </div>
        </div>
    </ModalData>
</template>

<script>
    import ElementMixin from "../mixins/ElementMixin";
    import {BasemapType} from '../mixins/Constants';
    import {capitalizeFirstLetter} from '@config/utils';

    export default {
        mixins: [
            ElementMixin,
        ],
        components:{
            ModalData: () => import(/* webpackChunkName: "modal" */ '@/app/shared/components/modals/Modal'),
            BasemapGallery: () => import(/* webpackChunkName: "basemap-gallery" */ './BasemapGallery'),
            BasemapOgc: () => import(/* webpackChunkName: "basemap-ogc" */ './BasemapOgc'),
        },
        provide () {
            return { parentValidator: this.$validator }
        },
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                default: null,
            },
            panelID: {
                type: String,
                default: 'default_layers',
            },
            keyChilds: {
                type: String,
                default: 'childs',
            },
            keyGroup: {
                type: String,
                default: 'group_id',
            },
            readonlyFormItem: {
                type: Boolean,
                default: true,
            },
            basemapType: {
                type: String,
                require: true,
                validator(value) {
                    return [BasemapType.GALLERY, BasemapType.OGC].includes(value)
                }
            },
            basemapUrl: {
                type: String,
                default: null,
            },
            basemapItems: {
                type: Array,
                default: () => {
                    return []
                },
            },
        },
        data() {
            return {
                pageID: this.panelID,
                form: {
                    id: null,
                    group_id: null,
                    resources: [],
                    item: null,
                }
            }
        },
        mounted() {

        },
        computed: {
            modalTitle() {
                return this.title ?? `${this.pageID}.basemap.${this.basemapType}.title`;
            },
            saveButtonCfg() {
                return this.basemapType == BasemapType.OGC ? {visible: false} : {title: this.$t(`${this.pageID}.basemap.buttons.save.name`)};
            },
            basemapComponent() {
                return `Basemap${capitalizeFirstLetter(this.basemapType)}`;
            }
        },
        methods: {
            initialize: function() {
            },
            reset: function() {
                Object.assign(this.$data.form, this.$options.data().form);
            },
            onSave: function(params = {}) {
                let {id = this.form.id, group_id = this.form.group_id, item = this.form.item} = params;
                this.$emit('select', {type: this.basemapType, ...{id, group_id, item}})
            },
            onClose: function() {
                this.$emit('close')
            },
            onSelectedItem: function(params) {
                this.onSave(params);
            }
        },
        watch: {
            show: {
                handler: function(newValue, oldValue) {
                    if(newValue) {
                        this.initialize();
                    }else{
                        this.reset();
                    }
                }
            }
        },
    }
</script>